/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ExecRiskApiAppApiV1EagerTasksForm990ModelsCommonTypesBusinessName } from './ExecRiskApiAppApiV1EagerTasksForm990ModelsCommonTypesBusinessName';
import {
    ExecRiskApiAppApiV1EagerTasksForm990ModelsCommonTypesBusinessNameFromJSON,
    ExecRiskApiAppApiV1EagerTasksForm990ModelsCommonTypesBusinessNameFromJSONTyped,
    ExecRiskApiAppApiV1EagerTasksForm990ModelsCommonTypesBusinessNameToJSON,
} from './ExecRiskApiAppApiV1EagerTasksForm990ModelsCommonTypesBusinessName';

/**
 * 
 * @export
 * @interface ExecRiskTransactionsRelatedOrg
 */
export interface ExecRiskTransactionsRelatedOrg {
    /**
     * 
     * @type {ExecRiskApiAppApiV1EagerTasksForm990ModelsCommonTypesBusinessName}
     * @memberof ExecRiskTransactionsRelatedOrg
     */
    OtherOrganizationName?: ExecRiskApiAppApiV1EagerTasksForm990ModelsCommonTypesBusinessName;
    /**
     * 
     * @type {string}
     * @memberof ExecRiskTransactionsRelatedOrg
     */
    TransactionTypeTxt?: string;
    /**
     * 
     * @type {number}
     * @memberof ExecRiskTransactionsRelatedOrg
     */
    InvolvedAmt?: number;
    /**
     * 
     * @type {string}
     * @memberof ExecRiskTransactionsRelatedOrg
     */
    MethodOfAmountDeterminationTxt?: string;
}

/**
 * Check if a given object implements the ExecRiskTransactionsRelatedOrg interface.
 */
export function instanceOfExecRiskTransactionsRelatedOrg(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ExecRiskTransactionsRelatedOrgFromJSON(json: any): ExecRiskTransactionsRelatedOrg {
    return ExecRiskTransactionsRelatedOrgFromJSONTyped(json, false);
}

export function ExecRiskTransactionsRelatedOrgFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExecRiskTransactionsRelatedOrg {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'OtherOrganizationName': !exists(json, 'OtherOrganizationName') ? undefined : ExecRiskApiAppApiV1EagerTasksForm990ModelsCommonTypesBusinessNameFromJSON(json['OtherOrganizationName']),
        'TransactionTypeTxt': !exists(json, 'TransactionTypeTxt') ? undefined : json['TransactionTypeTxt'],
        'InvolvedAmt': !exists(json, 'InvolvedAmt') ? undefined : json['InvolvedAmt'],
        'MethodOfAmountDeterminationTxt': !exists(json, 'MethodOfAmountDeterminationTxt') ? undefined : json['MethodOfAmountDeterminationTxt'],
    };
}

export function ExecRiskTransactionsRelatedOrgToJSON(value?: ExecRiskTransactionsRelatedOrg | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'OtherOrganizationName': ExecRiskApiAppApiV1EagerTasksForm990ModelsCommonTypesBusinessNameToJSON(value.OtherOrganizationName),
        'TransactionTypeTxt': value.TransactionTypeTxt,
        'InvolvedAmt': value.InvolvedAmt,
        'MethodOfAmountDeterminationTxt': value.MethodOfAmountDeterminationTxt,
    };
}

